module.exports = __webpack_public_path__ + "img/36b4e57.png";